module.exports = __webpack_public_path__ + "img/vertical_7_4_5010.5da81128.png";